import { NextPage } from 'next';
import React from 'react';

import CoreLayout from '@jpp/layouts/CoreLayout';
import ErrorTemplate from '@jpp/templates/Error';
import { NOT_FOUND_STATUS_CODE } from 'common/utils/constants';

const NotFoundPage: NextPage = () => {
  return (
    <CoreLayout title="404 Page Not Found" description="Error page not found">
      <ErrorTemplate statusCode={NOT_FOUND_STATUS_CODE} />
    </CoreLayout>
  );
};

export default NotFoundPage;
